<template>
	<el-row>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
		<el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
			<div class="solution-main-container">
				<div class="item" v-for="solution in data" :key="solution.id">
					<h2>{{solution.title}}</h2>
					<div class="content" v-for="item in solution.contents" :key="item.name">
						<div class="title"><span class="before" v-if="item.title"></span><span>{{item.title}}</span></div>
						<p v-for="content in item.content" :key="content.name" v-html="content">{{content}}</p>
					</div>
					<img :src="solution.src" />
				</div>
			</div>
		</el-col>
		<el-col :lg="4" :xl="4">
			<div class="hidden-md-and-down">&nbsp;</div>
		</el-col>
	</el-row>
</template>

<script>
	export default {
		name: 'SolutionMain',
		props: ['data']
	}
</script>

<style>
	@media (min-width:992px) {
		.solution-main-container {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
			background-color: #FFFFFF;
		}

		.solution-main-container .item {
			width: 100%;
			dispaly: flex;
			flex-direction: column;
			justify-content: center;
		}

		.solution-main-container .item .content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 100%;
			margin-bottom: 20px;
		}

		.solution-main-container .item .content .title {
			margin-bottom: 20px;
		}

		.solution-main-container .item .content p {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: rgba(132, 132, 132, 1);
			line-height: 24px;
			float: left;
			text-align: left;
			display: block;
		}

		.solution-main-container .item .content span {
			font-size: 16px;
			font-family: "microsoft yahei";
			color: rgba(87, 90, 102, 1);
			float: left;
			text-align: left;
		}

		.solution-main-container .item .content span.before {
			content: '';
			width: 4px;
			height: 16px;
			background: rgba(52, 156, 227, 1);
		}

		.solution-main-container .item img {
			margin-bottom: 20px;
		}

		.solution-main-container .item h2 {
			font-weight: 500;
			font-size: 20px;
			font-family: "microsoft yahei";
			color: rgba(51, 51, 51, 1);
			line-height: 102px;
			margin: 0;
		}
	}

	@media (max-width:992px) {
		.solution-main-container .item h2 {
			font-size: 18px;
			font-family: "microsoft yahei";
			color: rgba(51, 51, 51, 1);
			line-height: 60px;
			font-weight: 500;
		}

		.solution-main-container {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			width: 100%;
		}

		.solution-main-container .item {
			width: 90%;
			dispaly: flex;
			flex-direction: column;
			justify-content: center;
		}

		.solution-main-container .item .content {
			display: flex;
			flex-direction: column;
			justify-content: center;
			width: 100%;
			margin-bottom: 10px;
		}

		.solution-main-container .item .content .title {
			margin-bottom: 10px;
		}

		.solution-main-container .item .content p {
			font-size: 14px;
			font-family: "microsoft yahei";
			color: rgba(132, 132, 132, 1);
			line-height: 20px;
			float: left;
			text-align: left;
			display: block;
		}

		.solution-main-container .item .content p {
			margin-bottom: 10px;
		}

		.solution-main-container .item .content span {
			font-size: 16px;
			font-family: "microsoft yahei";
			color: rgba(87, 90, 102, 1);
			float: left;
			text-align: left;
		}

		.solution-main-container .item .content span.before {
			content: '';
			/* display: inline-block; */
			/* position: absolute; */
			width: 4px;
			height: 16px;
			background: rgba(52, 156, 227, 1);
		}

		.solution-main-container .item img {
			margin-bottom: 20px;
			width: 100%;
		}
	}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/SolutionMain.vue